const CONTAINER_LIGHT_LAYER = 1;

const CONTAINER_LIGHT_PRESET = {
    roughnessMultiplier: 0.82,
    minRoughness: 0.12,
    metalnessBoost: 0.02,
    envMapIntensity: 1.15,
    emissiveIntensity: 0.035,
    colorLift: 0.06,
};

const CONTAINER_LIGHT_OVERLAY_PRESET = {
    opacity: 0.18,
};

function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

function getContainerLightMaterialValues(base = {}) {
    const values = {};
    if (typeof base.roughness === 'number') {
        values.roughness = clamp(
            base.roughness * CONTAINER_LIGHT_PRESET.roughnessMultiplier,
            CONTAINER_LIGHT_PRESET.minRoughness,
            1
        );
    }
    if (typeof base.metalness === 'number') {
        values.metalness = clamp(
            base.metalness + CONTAINER_LIGHT_PRESET.metalnessBoost,
            0,
            1
        );
    }
    if (typeof base.envMapIntensity === 'number') {
        values.envMapIntensity = Math.max(
            base.envMapIntensity,
            CONTAINER_LIGHT_PRESET.envMapIntensity
        );
    }
    if (typeof base.emissiveIntensity === 'number') {
        values.emissiveIntensity = CONTAINER_LIGHT_PRESET.emissiveIntensity;
    }
    return values;
}

module.exports = {
    CONTAINER_LIGHT_LAYER,
    CONTAINER_LIGHT_OVERLAY_PRESET,
    CONTAINER_LIGHT_PRESET,
    getContainerLightMaterialValues,
};
